import { render, staticRenderFns } from "./PolipectomiaEndoscopicaIntestinoCrassoEditComponent.vue?vue&type=template&id=2cf99f13"
import script from "./PolipectomiaEndoscopicaIntestinoCrassoEditComponent.vue?vue&type=script&lang=js"
export * from "./PolipectomiaEndoscopicaIntestinoCrassoEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports